import axios from "axios";
import { isAuthenticated } from "../../../../commons/Auth/auth";
import { request, errorText, openBlob } from "../api";

// /api/accounting/sales — recurring invoices, SEPA direct debit runs, retentions
export const listRecurring = params => request.get("/sales/recurring", params);
export const getRecurring = id => request.get(`/sales/recurring/${id}`);
export const createRecurring = body => request.post("/sales/recurring", body);
export const updateRecurring = (id, body) => request.put(`/sales/recurring/${id}`, body);
export const deleteRecurring = id => request.del(`/sales/recurring/${id}`);
export const runRecurring = id => request.post(`/sales/recurring/${id}/run`, {});
export const runDueRecurring = () => request.post("/sales/recurring/run-due", {});

export const debitCandidates = params => request.get("/sales/direct-debit/candidates", params);
export const prenotify = (id, body) =>
  request.post(`/sales/direct-debit/invoices/${id}/prenotify`, body || {});
export const listDebitRuns = () => request.get("/sales/direct-debit/runs");
export const createDebitRun = body => request.post("/sales/direct-debit/runs", body);
export const debitRunXml = id => request.blob(`/sales/direct-debit/runs/${id}/xml`);

export const listRetentions = params => request.get("/sales/retentions", params);
export const releaseRetention = id => request.post(`/sales/retentions/${id}/release`, {});

export const listBankAccounts = () => request.get("/bank/accounts");

/** Customers of the tenant (same endpoint the offer form uses). */
export const listCustomers = async () => {
  const auth = isAuthenticated();
  const serviceProvider = auth?.employer?._id || auth?._id;
  const res = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/users/clients/limited`,
    { pageSize: 1000, pageNo: 0, serviceProvider },
    { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
  );
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export { errorText, openBlob };
